export const citizenship = [
  { value: "us_citizen", name: "US Citizen" },
  { value: "permanent_resident_alien", name: "Permanent Resident Alien" },
  {
    value: "non_permanent_resident_alien",
    name: "Non-Permanent Resident Alien",
  },
];



// WEBPACK FOOTER //
// ./src/constants/citizenship.js